import { LEDGER_CATEGORIES } from "@/lib/api";

export const catOf = (name) => LEDGER_CATEGORIES.find(c => c.name === name);
const GROUPS = ["Giriş", "Çıkış", "Diğer"];
export const CategorySelect = ({ value, onChange, onKeyDown, disabled, testId, name, allLabel }) => (
  <select name={name} value={value} onChange={e => onChange(e.target.value)} onKeyDown={onKeyDown} disabled={disabled} data-testid={testId}>
    {allLabel !== undefined && <option value="">{allLabel}</option>}
    {value && !catOf(value) && <option value={value}>{value}</option>}
    {GROUPS.map(g => <optgroup key={g} label={g}>{LEDGER_CATEGORIES.filter(c => c.group === g).map(c => <option key={c.name} value={c.name}>{c.name}</option>)}</optgroup>)}
  </select>
);

